import { render, staticRenderFns } from "./uploadAuthArrkcf.vue?vue&type=template&id=b72feb4a"
import script from "./uploadAuthArrkcf.vue?vue&type=script&lang=js"
export * from "./uploadAuthArrkcf.vue?vue&type=script&lang=js"
import style0 from "./uploadAuthArrkcf.vue?vue&type=style&index=0&id=b72feb4a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports